<div *ngIf="showBanner" class="privacyPolicyBanner">
  <div class="privacyPolicyBanner__description" i18n="@@PRIVACY_POLICY.BANNER.DESCRIPTION">
    Vestiaire Collective uses cookies to make your online shopping experience as enjoyable as possible and to offer you
    personalized content. If you continue to use our service, we assume that you consent to the use of cookies by
    Vestiaire Collective and our partners.
  </div>
  <div class="privacyPolicyBanner__actions">
    <div class="privacyPolicyBanner__actions__left">
      <vc-ref
        i18n-resource="@@LINKS.PRIVACY_POLICY"
        resource="/privacy-policy/"
        [anchor]="false"
        class="privacyPolicyBanner__link"
        i18n="@@PRIVACY_POLICY.BANNER.KNOW_MORE"
        >Learn More</vc-ref
      >
      <button
        class="privacyPolicyBanner__link"
        (click)="showPrivacyOptionsPopin()"
        i18n="@@PRIVACY_POLICY.BANNER.PARAMETERIZE"
      >
        Settings
      </button>
    </div>
    <button class="vc-btn vc-btn--secondary vc-btn--small" (click)="acceptAll()" i18n="@@PRIVACY_POLICY.BANNER.OK">
      OK
    </button>
  </div>
</div>
<!-- TODO : add no popin login restriction -->
